import {VirtualTeamsConstant as constants} from '../../../_constants/VirtualTeams/VirtualTeams.constants';

const initialStateSharedWith = { member_shared_with_loading : true, member_shared_with_data: [], member_shared_with_error: false };

export function virtualMemberSharedWith(state = initialStateSharedWith, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_MEMBER_UPDATE_LOADING:
            return {
                member_shared_with_loading: true,
                member_shared_with_data: [],
                member_shared_with_error: false
            };
        case constants.VIRTUAL_MEMBER_UPDATE_DATA:
            return {
                member_shared_with_loading: false,
                member_shared_with_data: action.virtual_team_shared_with,
                member_shared_with_error: false
            };
        case constants.VIRTUAL_MEMBER_UPDATE_ERROR:
            return {
                member_shared_with_loading: false,
                member_shared_with_data: [],
                member_shared_with_error: true
            };
        default:
            return state
    }
}

const initialStateShareTeam = { member_share_team_loading : true, member_share_team_data: [], member_share_team_error: false };

export function virtualMemberShareTeam(state = initialStateShareTeam, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_MEMBER_SHARE_TEAM_LOADING:
            return {
                member_share_team_loading: true,
                member_share_team_data: [],
                member_share_team_error: false
            };
        case constants.VIRTUAL_MEMBER_SHARE_TEAM_DATA:
            return {
                member_share_team_loading: false,
                member_share_team_data: action.virtual_team_share_team,
                member_share_team_error: false
            };
        case constants.VIRTUAL_MEMBER_SHARE_TEAM_ERROR:
            return {
                member_share_team_loading: false,
                member_share_team_data: [],
                member_share_team_error: true
            };
        default:
            return state
    }
}


const initialStateShareDelete = { member_share_del_loading : true, member_share_del_data: [], member_share_del_error: false };

export function virtualMemberShareDel(state = initialStateShareTeam, action) {
   
    switch (action.type) {
        case constants.VIRTUAL_MEMBER_SHARE_DELETE_LOADING:
            return {
                member_share_del_loading: true,
                member_share_del_data: [],
                member_share_del_error: false
            };
        case constants.VIRTUAL_MEMBER_SHARE_DELETE_DATA:
            return {
                member_share_del_loading: false,
                member_share_del_data: action.virtual_team_share_delete,
                member_share_del_error: false
            };
        case constants.VIRTUAL_MEMBER_SHARE_DELETE_ERROR:
            return {
                member_share_del_loading: false,
                member_share_del_data: [],
                member_share_del_error: true
            };
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/VirtualTeams/VirtualTeamShare/VirtualTeamShare.reducer.js